// extracted by mini-css-extract-plugin
export default {"certContainer":"styles_certContainer__ZxZGJ","curtain":"styles_curtain__DfY8f"};